/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Table_Created_OnInputs */

const en_options_api_keys_table_created_on = /** @type {(inputs: Options_Api_Keys_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created On`)
};

const fr_options_api_keys_table_created_on = /** @type {(inputs: Options_Api_Keys_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créée le`)
};

const de_options_api_keys_table_created_on = /** @type {(inputs: Options_Api_Keys_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt am`)
};

const it_options_api_keys_table_created_on = /** @type {(inputs: Options_Api_Keys_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creato il`)
};

const ru_options_api_keys_table_created_on = /** @type {(inputs: Options_Api_Keys_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано в`)
};

const es_options_api_keys_table_created_on = /** @type {(inputs: Options_Api_Keys_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado el`)
};

const zh_cn2_options_api_keys_table_created_on = /** @type {(inputs: Options_Api_Keys_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建于`)
};

const ja_options_api_keys_table_created_on = /** @type {(inputs: Options_Api_Keys_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const hi_options_api_keys_table_created_on = /** @type {(inputs: Options_Api_Keys_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पर बनाया`)
};

const pt_pt2_options_api_keys_table_created_on = /** @type {(inputs: Options_Api_Keys_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado em`)
};

/**
* | output |
* | --- |
* | "Created On" |
*
* @param {Options_Api_Keys_Table_Created_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_table_created_on = /** @type {((inputs?: Options_Api_Keys_Table_Created_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Table_Created_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_table_created_on(inputs)
	if (locale === "de") return de_options_api_keys_table_created_on(inputs)
	if (locale === "it") return it_options_api_keys_table_created_on(inputs)
	if (locale === "ru") return ru_options_api_keys_table_created_on(inputs)
	if (locale === "es") return es_options_api_keys_table_created_on(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_table_created_on(inputs)
	if (locale === "ja") return ja_options_api_keys_table_created_on(inputs)
	if (locale === "hi") return hi_options_api_keys_table_created_on(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_table_created_on(inputs)
	return en_options_api_keys_table_created_on(inputs)
});